/* 🎹 IAS · cart ladder meter — MODE-PAIRED (Deck laws 10-10).
   READS assets/ias-rates.json and NEVER computes its own percentages: every pct and every
   line of copy comes from the active mode block (cfg[cfg.mode] — tiers, strings).
   The Oct 22 flip is one JSON edit; this file needs no rewrite.
   Window-honest: in event mode outside the window the meter stays hidden (the discount
   would not fire, so the meter must not promise it); ?ias-ladder-preview=1 forces for QA.
   TWO MOUNTS: the cart-page section mount, and an injected mount inside the Section Store
   drawer's OPEN shadow root (same injectability precedent as ias-cart-slim.js, 09-28) with
   its own <style> since page CSS cannot cross the shadow boundary. Observer re-inserts if
   the app re-renders. Everything fails closed. */
(function () {
  'use strict';
  if (window.__iasLadderInit) return;   // theme.liquid loads this globally AND the cart section loads it — run once
  window.__iasLadderInit = 1;
  var cfg = null, attrs = null, prodCache = {};

  function getJSON(u) {
    return fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0));
  }
  function liveProduct(h) {
    if (!prodCache[h]) prodCache[h] = getJSON('/products/' + h + '.js');
    return prodCache[h];
  }
  function inWindow(c) {
    try {
      if (/[?&]ias-ladder-preview=1/.test(location.search)) return true;
      if (c.mode !== 'event') return true;               // window only gates the event
      var now = Date.now(), w = c.window || {};
      if (w.starts_at && now < Date.parse(w.starts_at)) return false;
      if (w.ends_at && now > Date.parse(w.ends_at)) return false;
      return true;
    } catch (e) { return false; }
  }
  function modeBlock(c) { return c[c.mode] || {}; }
  function modeStrings(c) { return modeBlock(c).strings || c.strings || {}; }
  function tiersFor(c) { return modeBlock(c).tiers || []; }
  function tierFor(c, keys) {
    var t = null;
    tiersFor(c).forEach(function (x) { if (keys >= x.min_keys && (!t || x.min_keys > t.min_keys)) t = x; });
    return t;
  }

  /* piano strip: white cells carry the stop counts straight from the mode's tiers
     (1 then each tier's min_keys, last one suffixed '+'), blacks are chromatic inlays */
  function paintKeys(host, keys) {
    var tiers = tiersFor(cfg);
    var stops = ['1'].concat(tiers.map(function (t, i) {
      return String(t.min_keys) + (i === tiers.length - 1 ? '+' : '');
    }));
    if (!host.childElementCount || host.childElementCount - 6 !== stops.length) {
      host.innerHTML = '<div class="ias-ladder__fill"></div>' + stops.map(function (w) {
        return '<div class="ias-ladder__white" data-count="' + w + '">' + w + '</div>';
      }).join('') +
        [10.5, 23.5, 48.5, 61.5, 74.5].map(function (left) {
          return '<div class="ias-ladder__black" style="left:' + left + '%"></div>';
        }).join('');
    }
    var fill = host.querySelector('.ias-ladder__fill');
    if (fill) fill.style.width = Math.min(100, Math.round(Math.min(keys, stops.length) * 100 / stops.length)) + '%';
    var cells = host.querySelectorAll('.ias-ladder__white');
    for (var i = 0; i < cells.length; i++) {
      var n = i + 1;
      cells[i].classList.toggle('is-reached', keys >= n);
      cells[i].classList.toggle('is-next', keys === n - 1);
    }
  }

  /* member SET from the ladder collection's own product list (pool parity law);
     null = load failed → spine fallback (ff != accessory) per item, under-promise only */
  var memberSet = null, memberLoad = null;
  function loadMembers() {
    if (memberLoad) return memberLoad;
    memberLoad = (function pull(page, acc) {
      return fetch('/collections/ladder-eligible/products.json?limit=250&page=' + page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.products) return acc.length ? acc : null;
          j.products.forEach(function (p) { acc.push(p.handle); });
          return (j.products.length === 250 && page < 4) ? pull(page + 1, acc) : acc;
        })
        .catch(function () { return acc.length ? acc : null; });
    })(1, []).then(function (list) {
      memberSet = list && list.length ? {} : null;
      if (memberSet) list.forEach(function (h) { memberSet[h] = 1; });
      return memberSet;
    });
    return memberLoad;
  }

  function render(root, cart) {
    var items = cart.items || [];
    loadMembers().then(function (set) {
      var keys = 0;
      items.forEach(function (i) {
        var m = set ? !!set[i.handle] : null;
        if (m === null) {
          var a = attrs[i.handle];
          m = !!(a && a.ff !== 'accessory');
        }
        if (m) keys += i.quantity;
      });
      renderWithKeys(root, cart, keys);
    });
  }

  function renderWithKeys(root, cart, keys) {
    var items = cart.items || [];

    paintKeys(root.querySelector('[data-ladder-keys]'), keys);

    var s = modeStrings(cfg);
    var tierEl = root.querySelector('[data-ladder-tier]');
    var tierCopy = '';
    if (keys === 1) tierCopy = s.k1 || '';
    else if (keys === 2) tierCopy = s.k2 || '';
    else if (keys === 3) tierCopy = s.k3 || '';
    else if (keys >= 4) tierCopy = s.k4 || '';
    tierEl.textContent = tierCopy;

    var shipEl = root.querySelector('[data-ladder-ship]');
    var shipCents = (cfg.free_ship_threshold || 0) * 100;
    if (shipCents && cart.total_price < shipCents) {
      shipEl.textContent = (s.ship_gap || '+{amt} to free shipping').replace('{amt}', money(shipCents - cart.total_price));
    } else {
      shipEl.textContent = '';
    }

    var shelfEl = root.querySelector('[data-ladder-shelf]');
    var saleHandles = items.map(function (i) { return i.handle; });
    Promise.all(saleHandles.map(liveProduct)).then(function (ps) {
      var save = 0, any = false;
      items.forEach(function (i, idx) {
        var p = ps[idx];
        if (!p || !p.tags || p.tags.indexOf('sale') === -1) return;
        any = true;
        for (var v = 0; v < (p.variants || []).length; v++) {
          var vr = p.variants[v];
          if (vr.id === i.variant_id && vr.compare_at_price > vr.price) {
            save += (vr.compare_at_price - vr.price) * i.quantity;
          }
        }
      });
      if (!any) { shelfEl.textContent = ''; return; }
      var t = tierFor(cfg, keys);
      if (t && save > 0) {
        shelfEl.textContent = (s.shelf_combo || 'Shelf deal −{amt} · Chord −{pct}%')
          .replace('{amt}', money(save)).replace('{pct}', String(t.pct));
      } else if (save > 0) {
        shelfEl.textContent = 'Shelf deal −' + money(save);
      } else {
        shelfEl.textContent = '';
      }
    });
  }

  var SKEL = '<div class="ias-ladder__keys" data-ladder-keys aria-hidden="true"></div>' +
    '<p class="ias-ladder__tier" data-ladder-tier></p>' +
    '<p class="ias-ladder__ship" data-ladder-ship></p>' +
    '<p class="ias-ladder__shelf" data-ladder-shelf></p>';

  /* shadow-root mount: page CSS cannot cross the boundary, so the drawer mount carries
     its own <style> (same rules as ias-ladder.css core, black/white law) */
  var DRAWER_CSS =
    /* motivator: rainbow fill sits UNDER the stop labels, never over them */
    '.ias-ladder{margin:0 0 12px;padding:0 0 12px;border-bottom:1px solid #E2E2DE;font-family:inherit}' +
    '.ias-ladder[hidden]{display:none!important}' +
    '.ias-ladder__keys{display:flex;height:26px;border:1px solid #E2E2DE;border-radius:999px;overflow:hidden;background:#F5F5F3;position:relative}' +
    '.ias-ladder__fill{position:absolute;left:0;top:0;bottom:0;width:0;z-index:0;background:linear-gradient(90deg,#ff4878,#ffaa3c,#fae650,#50dc8c,#46aaff,#9664ff);transition:width .35s ease}' +
    '.ias-ladder__white{flex:1 1 0;position:relative;z-index:1;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800;letter-spacing:.02em;color:#8a8a86;border-right:1px solid rgba(17,17,17,.08)}' +
    '.ias-ladder__white:last-child{border-right:0}' +
    '.ias-ladder__white.is-reached{color:#111}' +
    '.ias-ladder__white.is-next{color:#111;background:rgba(255,255,255,.6)}' +
    '.ias-ladder__black{display:none}' +
    '.ias-ladder__tier{margin:8px 0 0;font-size:12.5px;line-height:16px;font-weight:800;color:#111}' +
    '.ias-ladder__ship,.ias-ladder__shelf{margin:3px 0 0;font-size:12px;line-height:15px;color:#5f6368}' +
    '.ias-ladder__tier:empty,.ias-ladder__ship:empty,.ias-ladder__shelf:empty{display:none}' +
    '@media (prefers-reduced-motion:reduce){.ias-ladder__fill{transition:none}}' +
    /* line items ~18% slimmer so items + motivator + checkout fit a 375px phone */
    '.cart-line-item{padding-top:11px!important;padding-bottom:11px!important}' +
    '.cart-line-image{width:58px!important;height:58px!important;min-width:58px!important;flex:0 0 58px!important}' +
    '.cart-line-image img{max-width:100%!important;max-height:100%!important}' +
    '.cart-line-title{font-size:13px!important;line-height:17px!important}' +
    '.cart-line-subtitle{font-size:11.5px!important;line-height:14px!important;margin-top:2px!important}' +
    '.cart-line-discounts{font-size:11px!important;line-height:13px!important;margin-top:3px!important}' +
    '.cart-line-discounts span{display:block!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}' +
    '.cart-line-discounts svg{display:inline-block;width:10px;height:10px;margin-right:4px;vertical-align:-1px}' +
    '.cart-line-quantity-row{margin-top:6px!important}' +
    '.cart-line-quantity{height:28px!important}' +
    '.cart-line-price{font-size:13px!important}' +
    '@media (max-width:480px){.cart-trust-badges{display:none!important}.cart-payment-icons{margin-top:6px!important}}';

  var drawerRoot = null;
  function injectDrawer() {
    var host = document.querySelector('section-store--cart-block');
    if (!host || !host.shadowRoot) return;
    var sr = host.shadowRoot;
    if (sr.querySelector('[data-ias-ladder-drawer]')) { drawerRoot = sr.querySelector('[data-ias-ladder-drawer]'); return; }
    var wrap = document.createElement('div');
    wrap.setAttribute('data-ias-ladder-drawer', '');
    wrap.className = 'ias-ladder';
    wrap.hidden = true;
    wrap.innerHTML = SKEL;
    var style = document.createElement('style');
    style.textContent = DRAWER_CSS;
    wrap.appendChild(style);
    var foot = sr.querySelector('.cart-footer');   // top of the footer: right above totals + checkout
    if (foot) foot.insertBefore(wrap, foot.firstChild);
    else sr.appendChild(wrap);
    // the ladder applies with no code — start the code box folded (once per page; shoppers can reopen it)
    var tg = sr.querySelector('.cart-discount-toggle[aria-expanded="true"]');
    if (tg && !host.__iasCodeFolded) { host.__iasCodeFolded = 1; tg.click(); }
    drawerRoot = wrap;
    refresh();
  }
  /* line-item discount tags show the native discount's title; drop the retired event prefix
     at display time (the discounts themselves are never touched from the theme) */
  function cleanTags(sr) {
    [].forEach.call(sr.querySelectorAll('.cart-line-discounts span, .cart-discount-total-row span'), function (el) {
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 3 && /Opening Day\s*·\s*/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/Opening Day\s*·\s*/g, '');
      }
    });
  }
  function watchDrawer() {
    var tries = 0;
    (function hook() {
      var host = document.querySelector('section-store--cart-block');
      if (!host || !host.shadowRoot) { if (tries++ < 40) setTimeout(hook, 700); return; }
      injectDrawer();
      new MutationObserver(function () {
        if (!host.shadowRoot.querySelector('[data-ias-ladder-drawer]')) { drawerRoot = null; injectDrawer(); }
        cleanTags(host.shadowRoot);
      }).observe(host.shadowRoot, { childList: true, subtree: true });
      cleanTags(host.shadowRoot);
    })();
  }

  function roots() {
    var r = [];
    var page = document.querySelector('[data-ias-ladder]');
    if (page) r.push(page);
    if (drawerRoot && drawerRoot.isConnected) r.push(drawerRoot);
    return r;
  }

  function refresh() {
    if (!cfg || !attrs) return;
    var rs = roots();
    if (!rs.length) return;
    getJSON('/cart.js').then(function (cart) {
      if (!cart) return;
      rs.forEach(function (root) {
        if (!cart.item_count) { root.hidden = true; return; }
        root.hidden = false;
        render(root, cart);
      });
    });
  }

  function init() {
    var page = document.querySelector('[data-ias-ladder]');
    var ratesUrl = page ? page.getAttribute('data-rates') : (window.IAS_RATES_URL || null);
    var mapUrl = page ? page.getAttribute('data-map') : (window.IAS_MAP_URL || null);
    if (!ratesUrl || !mapUrl) return;
    Promise.all([getJSON(ratesUrl), getJSON(mapUrl)])
      .then(function (res) {
        cfg = res[0]; var map = res[1];
        attrs = (map && map.attrs) || null;
        if (!cfg || !attrs || cfg.mode === 'off' || !tiersFor(cfg).length || !inWindow(cfg)) return; // fail closed
        document.body.classList.add('ias-event-on');   // pizzazz CSS reads this site-wide
        /* QA-CLEAN 10-18 (ITEM 0 audit, conflict #3): this used to rewrite window.fetch and XMLHttpRequest for the WHOLE site, and poll
           28 s for the "Section Store" cart app block, which is gone, just to repaint a ladder that renders in two places only.
           Now: nothing to paint → nothing runs. Something to paint → listen to Dawn's own cart event (+ the IAS one), never patch the browser. */
        if (!document.querySelector('[data-ias-ladder], section-store--cart-block')) return;
        ['cart:updated', 'cart:build', 'ajaxProduct:added', 'cart:open'].forEach(function (ev) {
          document.addEventListener(ev, refresh);
        });
        try { if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 300); }); } catch (e) {}
        if (document.querySelector('section-store--cart-block')) watchDrawer();
        refresh();
      });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
